import { memo } from 'react'
import { useId } from '@floating-ui/react'
import classNames from 'classnames'

import { HTML_ELEMENT_TAB_INDEX_NOT_TABABLE } from '../../../constants/html'
import { getQaSelector } from '../../../utils/common'
import { stopPropagation } from '../../../utils/events'
import { setRef } from '../../../utils/react'
import { useFloatingListItem } from '../../Floating'
import { useSelectContext } from '../Select.hooks'

import { QA_NAME_LIST_ITEM_CONTEXT } from './SelectDropdownListItem.constants'

import * as styles from './SelectDropdownListItem.module.css'

/*
 * Base select dropdown list item for composing component.
 */
function SelectDropdownListItem({
  Content,
  className = styles.SelectDropdownListItem,
  contentProps,
  disabled,
  qaName,
  ref,
  value,
  ...itemProps
}) {
  const id = useId()

  const {
    activeIndex,
    getFloatingItemProps,
    handleSelect,
    multi,
    value: selectedValue,
  } = useSelectContext()

  const { index, ref: setFloatingRef } = useFloatingListItem()

  function handleClick(event) {
    stopPropagation(event)

    if (!disabled) {
      handleSelect(value)
    }
  }

  const isSelected = selectedValue
    ? multi
      ? selectedValue?.find(
          selectedValueItem => selectedValueItem.value === value.value
        )
      : selectedValue?.value === value.value
    : false
  const isHovered = activeIndex === index

  const mods = {
    [styles.active]: isSelected,
    [styles.disabled]: disabled,
    [styles.hover]: isHovered,
  }

  function handleSetRef(node) {
    setFloatingRef(node)

    setRef(ref, node)
  }

  const listItemClassName = classNames(className, mods)

  const qaProps = getQaSelector({
    context: QA_NAME_LIST_ITEM_CONTEXT,
    def: QA_NAME_LIST_ITEM_CONTEXT,
    value: qaName,
  })

  return (
    <li
      {...itemProps}
      {...qaProps}
      {...getFloatingItemProps({
        onClick: handleClick,
      })}
      aria-selected={isHovered && isSelected}
      className={listItemClassName}
      id={id}
      ref={handleSetRef}
      role='option'
      tabIndex={HTML_ELEMENT_TAB_INDEX_NOT_TABABLE}
    >
      <Content
        {...contentProps}
        disabled={disabled}
        isHovered={isHovered}
        isSelected={isSelected}
        value={value}
      />
    </li>
  )
}

export default memo(SelectDropdownListItem)
